
// Default data for Admin sections
// Using string icons (emojis) instead of React Elements

// Services with string icons instead of React components
export const categoryData = [
  {
    icon: "🧠",
    title: "Anxiety & Stress Management",
    description: "Learn effective techniques to manage anxiety and reduce stress in your daily life.",
    href: "/services/anxiety",
    color: "bg-ifind-aqua/10"
  },
  {
    icon: "❤️",
    title: "Relationship Counseling",
    description: "Improve communication and resolve conflicts in your personal relationships.",
    href: "/services/relationships",
    color: "bg-ifind-purple/10"
  },
  {
    icon: "👨‍👩‍👧‍👦",
    title: "Family Therapy",
    description: "Address family conflicts and strengthen bonds through guided sessions.",
    href: "/services/family",
    color: "bg-ifind-teal/10"
  },
  {
    icon: "↗️",
    title: "Personal Growth",
    description: "Discover your potential and develop strategies for self-improvement and resilience.",
    href: "/services/personal-growth",
    color: "bg-ifind-charcoal/10"
  }
];

// Default testimonials
export const initialTestimonials = [
  {
    name: "Rebecca T.",
    location: "New York",
    rating: 5,
    text: "After months of struggling with anxiety, my sessions have been life-changing. I've learned techniques that help me manage stressful situations effectively.",
    date: "2 weeks ago",
    imageUrl: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1976&auto=format&fit=crop"
  },
  {
    name: "Mark L.",
    location: "Chicago",
    rating: 5,
    text: "The counseling helped my wife and I improve our communication in ways we never thought possible. Our relationship is stronger than ever.",
    date: "1 month ago",
    imageUrl: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=2070&auto=format&fit=crop"
  },
  {
    name: "Samantha J.",
    location: "Los Angeles",
    rating: 5,
    text: "The mindfulness techniques I learned have completely transformed how I handle stress at work. I'm more productive and happier than I've been in years.",
    date: "3 weeks ago",
    imageUrl: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1974&auto=format&fit=crop"
  }
];

// Default services
export const initialServices = [
  {
    icon: "🧠",
    title: "Anxiety & Stress Management",
    description: "Learn effective techniques to manage anxiety and reduce stress in your daily life.",
    href: "/services/anxiety",
    color: "bg-ifind-aqua/10"
  },
  {
    icon: "❤️",
    title: "Relationship Counseling",
    description: "Improve communication and resolve conflicts in your personal relationships.",
    href: "/services/relationships",
    color: "bg-ifind-purple/10"
  },
  {
    icon: "👨‍👩‍👧‍👦",
    title: "Family Therapy",
    description: "Address family conflicts and strengthen bonds through guided sessions.",
    href: "/services/family",
    color: "bg-ifind-teal/10"
  },
  {
    icon: "↗️",
    title: "Personal Growth",
    description: "Discover your potential and develop strategies for self-improvement and resilience.",
    href: "/services/personal-growth",
    color: "bg-ifind-charcoal/10"
  }
];
